import http from './http.js';

//保存评论
export function getFarmInvest(farm_id,year){
    return http.get(`/user/farm/get_farm_invest/`+farm_id+'/'+year)
}


export function getFarmFeeList(farm_id,year,type,param){
    return http.get(`/user/farm/get_farm_fee_list/`+farm_id+'/'+year+'/'+type,param)
}


export function getFarmIncome(farm_id,year){

    return http.get(`/user/farm/get_farm_income/`+farm_id+'/'+year)
}
export function getFarmProfit(farm_id,year){

    return http.get(`/user/farm/get_farm_profit/`+farm_id+'/'+year)
}

